import React, { useState, createRef } from 'react';
import PropTypes from 'prop-types';
import Search from './Search';
import ResultsHeader from './ResultsHeader';
import Pagination from './Pagination';
import CollectionModal from './CollectionModal';
import useItems from '../hooks/useItems';
import useWindowLocationHash from '../hooks/useWindowLocationHash';
import renderItemCards from '../actions/renderItemCards';
import disablePageScroll from '../actions/disablePageScroll';
import useModalItemFromHash from '../hooks/useModalItemFromHash';

const CollectionItemsBlock = ({collectionId, tooltip, language}) => {
	const [searchValue, setSearchValue] = useState('');
	const [params, setParams] = useState({id: collectionId, p: 1});
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [currentModalItemIndex, setCurrentModalItemIndex] = useState(null);
	const [itemsArray, setItemsArray, pagesArray] = useItems('collection', params, language);
	const [activePage, setActivePage] = useState(1);
	disablePageScroll(modalIsOpen);
	const searchInput = createRef();
	const [windowLocationHash, setWindowLocationHash] = useWindowLocationHash(itemsArray);
	const [itemId, setItemId] = useState(null);
	const [modalItem, setModalItem] = useModalItemFromHash({
		language,
		itemsArray,
		pagesArray,
		windowLocationHash,
		setCurrentModalItemIndex,
		setModalIsOpen,
		itemId,
	});

	const items = () => {
		const hasHashOnPageLoad = modalItem.length > 0 && !itemId;
		const noHashOnPageLoad = itemsArray.length > 0 && itemId;
		
		if (hasHashOnPageLoad) {
			return {
				array: modalItem,
				setterFn: setModalItem,
			};
		}

		if (noHashOnPageLoad) {
			return {
				array: itemsArray,
				setterFn: setItemsArray,
			};
		}
	}

	return (
		<> 
			<Search 
				searchValue={searchValue}
				setSearchValue={setSearchValue}
				setParams={setParams}
				setActivePage={setActivePage}
				ref={searchInput}
				setTooltip={tooltip}
			/>
			<ResultsHeader 
				searchTerm={params.q}
				itemsArray={itemsArray}
				language={language}
			/>
			<ul className='cards-layout__grid-container'>
				{renderItemCards(itemsArray, setWindowLocationHash, setItemId, setCurrentModalItemIndex, setModalIsOpen)}
			</ul>
			<Pagination 
				pagesArray={pagesArray}
				activePage={activePage}
				setActivePage={setActivePage}
				setParams={setParams}
				searchInput={searchInput}
			/>
			{
				(modalItem.length > 0 || itemId) && modalIsOpen
					? <CollectionModal
						setModalIsOpen={setModalIsOpen}
						modalContent={items().array[currentModalItemIndex]}
						setModalContent={items().setterFn} 
						currentModalItemIndex={currentModalItemIndex}
						setCurrentModalItemIndex={setCurrentModalItemIndex}
						modalContentLength={items().array.length}
						language={language}
						setWindowLocationHash={setWindowLocationHash}
						setItemId={setItemId}
					/>
					: null
			}
		</>
	)
}

export default CollectionItemsBlock;

CollectionItemsBlock.propTypes = {
	collectionId: PropTypes.string,
	tooltip: PropTypes.string,
	language: PropTypes.string,
}